<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h3>Edit FAQ</h3>
            <div v-if="pageLoading" class="mt-3">
                Loading...
            </div>
            <EditElement :elementIdProp="pageId" category_id="6"></EditElement>
        </div>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";

export default {
    name: 'editFAQ',
    components: {
        EditElement,
    },
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'FAQs',
                    to: '/faqs/all'
                }, {
                    text: 'Edit FAQ',
                    href: '#'
                }
            ],
            pageId: null,
        };
    },
    created() {
        this.pageId = this.$route.params.id;
    },
}
</script>